/**
 * Browser wiring for the custom color setup fee.
 *
 * Everything DOM- and network-shaped lives here: the cart fetches, the event
 * subscriptions, and the section re-render. The rule itself is in
 * custom-color-model.js and the protocol is in custom-color-reconciler.js.
 */
(function () {
  'use strict';

  const constants = window.CustomColorConstants;
  const reconcilerApi = window.CustomColorReconciler;
  if (!constants || !reconcilerApi) return;

  const feeVariantId = constants.config().feeVariantId;
  if (!feeVariantId) return;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart read ' + r.status);
      return r.json();
    });
  }

  function addLines(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add ' + r.status);
      return r.json();
    });
  }

  function changeLine(id, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change ' + r.status);
      return r.json();
    });
  }

  /**
   * Re-render whatever cart UI is on screen.
   *
   * Mirrors how main.js refreshes after its own add: the cart page owns a
   * cart-form that can refresh itself, and elsewhere the header and drawer
   * re-render from section markup.
   */
  function refresh() {
    const cartForm = document.querySelector('cart-form');
    if (document.querySelector('.template-cart') && cartForm && cartForm.enableAjaxUpdate) {
      cartForm.refresh();
      return Promise.resolve();
    }

    const elements = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);
    if (!elements.length) return Promise.resolve();

    const ids = elements.map(function (el) { return el.dataset.sectionId; });
    const url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        elements.forEach(function (el) {
          const markup = sections[el.dataset.sectionId];
          if (markup && typeof el.updateFromCartChange === 'function') {
            el.updateFromCartChange(markup);
          }
        });
      })
      .catch(function () {
        // A stale count in the header is not worth an error in front of a
        // customer. The next cart render corrects it.
      });
  }

  const reconciler = reconcilerApi.createReconciler({
    feeVariantId: feeVariantId,
    readCart: readCart,
    addLines: addLines,
    changeLine: changeLine,
    refresh: refresh,
    log: function (message) {
      console.log(message); // eslint-disable-line
    },
  });

  function trigger() {
    reconciler.schedule();
  }

  document.addEventListener('on:cart:add', trigger);
  document.addEventListener('on:cart:change', trigger);
  // side-drawer.js derives this event name from the drawer's data-name
  // attribute: `on:${this.dataset.name}:after-open` (side-drawer.js, open()).
  // sections/cart-drawer.liquid sets data-name="cart-drawer" on <cart-drawer>,
  // so the real event is on:cart-drawer:after-open. If that data-name is ever
  // renamed, this listener goes silently dead again unless updated here too.
  document.addEventListener('on:cart-drawer:after-open', trigger);
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) trigger();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') trigger();
  });

  trigger();
})();
